export default {
    methods: {
        /**
         * 设置cookie
         * @param cname
         * @param cvalue
         * @param exdays
         */
        $setCookie(cname, cvalue, exdays) {
            let d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            let expires = 'expires=' + d.toGMTString();
            document.cookie = cname + '=' + cvalue + '; ' + expires + '; path=/;';
        },
        /**
         * 读取cookie
         * @param cname
         * @returns {*}
         */
        $getCookie(cname) {
            let name = cname + '=';
            let ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i].trim();
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        },
        /**
         * 获取地址栏参数
         * @param name
         * @returns {*}
         */
        $getQueryString(name) {
            let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
            let r = window.location.search.substr(1).match(reg);
            if (r !== null) {return decodeURIComponent(r[2])}
            return '';
        },
        /**
         * 图片转base64
         * @param imgUrlArr (url数组)
         */
        $getImgToBase64(imgUrlArr) {
            return new Promise((resolve) => {
                let count = 0;// 已完成渲染数
                let arr = [];
                imgUrlArr.map((item, index) => {
                    let canvas = document.createElement('canvas');
                    let ctx = canvas.getContext('2d');
                    let img = new Image();
                    img.setAttribute('crossOrigin', 'anonymous');
                    img.onload = function () {
                        canvas.height = img.height;
                        canvas.width = img.width;
                        ctx.drawImage(img, 0, 0);
                        arr[index] = canvas.toDataURL('image/png');
                        count++;
                        if (count === imgUrlArr.length) {
                            resolve(arr);
                            // return arr;
                        }
                    };
                    img.onerror = function () {
                        arr[index] = '';
                        count++;
                        if (count === imgUrlArr.length) {
                            resolve(arr);
                        }
                    };
                    img.src = item;
                });
            });
        },
        /**
         * 获取随机数(整数)(结果包括最小值、不包含最大值)
         * @param min (最小值)
         * @param max (最大值)
         * @returns {number}
         */
        $getRand(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },
        /**
         * 拆分国际手机号
         * @param mobile
         */
        $SMS(mobile = '') {
            // 判断手机号不能为空
            if (!mobile) {
                return {SMSCode: '', mobile: ''};
            }
            const SMSCodeReg = /\+[^\]]+-/g;// 短信前缀正则
            const mobileReg = /([^-]+)$/g;// 手机号正则
            // 短信前缀
            let SMSCode = '86';
            if (mobile.match(SMSCodeReg)) {
                SMSCode = mobile.match(SMSCodeReg)[0].replace(/[+|-]/g, '') || '86';
            }
            // 手机号
            const mobileNum = mobile.match(mobileReg) ? mobile.match(mobileReg)[0].replace(/[+|-]/g, '') : '';
            return {SMSCode: SMSCode, mobile: mobileNum};
        },
        /**
         * 移动端适配
         * @param type false-关闭、true-开启(default)
         */
        $adaptationM(type = true) {
            if (type) {
                let d = navigator.userAgent.match(/Android[\S\s]+AppleWebkit\/(\d{3})/i);
                let l = navigator.userAgent.match(/U3\/((\d+|\.){5,})/i);
                let c = l && parseInt(l[1].split('.').join(''), 10) >= 80;
                let p = navigator.appVersion.match(/(iphone|ipad|ipod)/gi);
                let s = window.devicePixelRatio || 1;
                p || d && d[1] > 534 || c || (s = 1);
                let u = 1 / s;
                let m = document.querySelector('meta[name="viewport"]');
                m || (m = document.createElement('meta'), m.setAttribute('name', 'viewport'), document.head.appendChild(m));
                m.setAttribute('content', 'width=device-width,user-scalable=no,initial-scale=' + u + ',maximum-scale=' + u + ',minimum-scale=' + u);
                document.documentElement.style.fontSize = 50 * s + 'px';
            } else {
                let m = document.querySelector('meta[name="viewport"]');
                m || (m = document.createElement('meta'), m.setAttribute('name', 'viewport'), document.head.appendChild(m));
                m.setAttribute('content', '');
                document.documentElement.style.fontSize = 'initial';
            }
        },
        /**
         * 最大字节长度
         * @param str
         * @param maxByteLength
         * @returns {number}
         */
        $maxByteLength(str, maxByteLength) {
            const strArr = str.split('.');// 获取到每一层对象
            let nowStr = this;// 当前的字符串
            let newStr = this;// 重新赋值的字符串
            let tooLong = false;// 输入的内容是否超出
            strArr.forEach((item, index) => {
                nowStr = nowStr[item];// 获取到当前字符串
                if (strArr.length - 1 !== index) {
                    newStr = newStr[item];// 获取前一层对象
                }
            });
            // 当前字符串字节长度
            let byteLength = nowStr.byteLength();
            while (byteLength > maxByteLength) {
                tooLong = true;
                nowStr = nowStr.substring(0, nowStr.length - 1);
                byteLength = nowStr.byteLength();
            }
            // 新字符串赋值
            newStr[strArr[strArr.length - 1]] = nowStr;
            if (byteLength === maxByteLength || tooLong) {
                return nowStr.length;
            } else {
                return maxByteLength;
            }
        },
        /**
         * 币种简称转换
         * @param currency
         * @returns {string}
         */
        $currencyAbbr(currency) {
            switch (currency) {
                case 'CNY':
                    return '¥ ';
                case 'USD':
                    return '$ ';
                case 'EUR':
                    return '€ ';
                default:
                    return '¥ ';
            }
        },
         /**
         * 币种简称转换2
         * @param currency
         * @returns {string}
         */
          $currencyUnit(currency) {
            switch (currency) {
                case 'CNY':
                    return '元';
                case 'USD':
                    return '$';
                case 'EUR':
                    return '€';
                default:
                    return '元';
            }
        },     
        /**
         * 是否是中文
         */
        $isZh() {
            return this.$getCookie('i18n') === 'zhCHS';
        },
        /**
         * 控制输入金额
         */
        $filterNumber: ({value = '', fixed = 0, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER,ebleEmpty = false}) => {
            value = value.trim();// 先去空格
            if (ebleEmpty) {
                if (value === '' || value.includes('-')) {
                    return '';
                }
            }
            // 没有值就直接返最小值
            if (!value) {
                if (min < 0) {
                    return String(0);
                } else {
                    return String(min);
                }
            }
            // 带负号
            if (value === '-') {
                if (min < 0) {// 最小值小于0才能输入负号
                    return value;
                } else {
                    return String(min);
                }
            }

            if (value === '-0') {
                if (min < 0) {// 最小值小于0才能输入负号
                    return value;
                } else {
                    return String(min);
                }
            }

            if (value === '-0.') {
                if (min < 0) {// 最小值小于0才能输入负号
                    return value;
                } else {
                    return String(min);
                }
            }

            // 转数值
            const numValue = Number(value);
            if (isNaN(numValue)) {
                return false;
            } else if (numValue >= max) {
                return String(max);
            } else if (numValue < min) {
                return String(min);
            } else {
                const decimal = value.split('.');// 小数

                if (decimal[1] === undefined) {// 没点
                    return String(numValue);
                } else if (decimal[1] === '') {// 有点没值
                    return String(numValue) + (fixed === 0 ? '' : '.');
                } else {// 有点有值
                    return `${decimal[0].includes('-0') ? '-' : ''}${String(Number(decimal[0]))}${fixed !== 0 ? '.' : ''}${decimal[1].substr(0, fixed)}`;
                }
            }
        },
        /**
         * 是否在国外
         */
        $isAbroad() {
            let lang = navigator.language || navigator.userLanguage || 'zh-CN'; // 常规浏览器语言和IE浏览器
            lang = lang.substr(0, 2); // 截取lang前2位字符    
            return lang !== 'zh';       
        },

        /**
         * 是否海外链接
         */
        $isIntl() {
            return location.origin.includes('https://intl.3j-mall.com');       
        },
        /**
         * 国外默认en,国内zh
         */
        $setLanguage() {
            let isintl = location.origin.includes('https://intl.3j-mall.com'); // 常规浏览器语言和IE浏览器
            if (!this.$getCookie('i18n')) {
                if (isintl) {
                    this.$setCookie('i18n','en',365);
                    this.$setCookie('currency', 'USD', 365);
                } else {
                    this.$setCookie('i18n','zhCHS',365);
                    this.$setCookie('currency', 'CNY', 365);
                }
            }  
        },
        /**
         * 币种全称转换
         * @param currency
         * @returns {string}
         */
        $currencyFull(currency) {
            switch (currency) {
                case 'CNY':
                    return this.$t('message.CNY');
                case 'USD':
                    return this.$t('message.USD');
                case 'EUR':
                    return this.$t('message.EUR');
                default:
                    return this.$t('message.CNY');
            }
        },
        /**
         * 倒计时格式化
         * @param time
         * @param ms
         * @returns {string}
         */
        $countdownFormat(time = -1, ms = false) {
            // 判断毫秒标志位
            if (ms) {
                if (time >= 0 && time < 10) {
                    return '00' + String(time);
                }
                if (time < 100) {
                    return '0' + String(time);
                }
                if (time >= 100) {
                    return String(time);
                }
                return '000';
            } else {
                if (time < 0) {
                    return '00';
                }
                if (time < 10) {
                    return '0' + String(time);
                }
                return String(time);
            }
        },
        /**
         * 数字输入限制
         * @param dataStr
         * @param minNum
         * @param maxNum
         * @param dLength
         */
        $numLimit(dataStr, minNum, maxNum, dLength) {
            const dataArr = dataStr.split('.');// 获取到每一层对象
            let nowData = this;// 当前的数据对象
            let prevData = this;// 上一层的数据对象
            dataArr.forEach((item, index) => {
                nowData = nowData[item];// 获取到当前字符串
                if (dataArr.length - 1 !== index) {
                    prevData = prevData[item];// 获取前一层对象
                }
            });

            nowData = Number(nowData);// 转换成数值类型

            // 如果输入不是数字则返回空
            if (isNaN(nowData)) {
                nowData = '';
            } else {
                // 四舍五入
                if (String(nowData).includes('.') && Number(String(nowData).split('.')[1]) > Number(dLength)) {
                    nowData = Number(nowData.toFixed(dLength));
                }
                // 大小约束
                if (nowData > maxNum) {
                    nowData = Number(maxNum);
                } else if (nowData < Number(minNum)) {
                    nowData = Number(minNum);
                }
            }

            // 赋值
            prevData[dataArr[dataArr.length - 1]] = String(nowData);
        },
        /**
         * 创建定时器通用方法
         * @param handler
         * @param timeout
         */
        $setInterval(handler, timeout) {
            const timer = setInterval(() => {
                handler();
            }, timeout);
            this.$once('hook:beforeDestroy', () => {
                clearInterval(timer);
            });
            return timer;
        },
        /**
         * 创建延时器通用方法
         * @param handler
         * @param timeout
         */
        $setTimeout(handler, timeout) {
            const timer = setTimeout(() => {
                handler();
            }, timeout);
            this.$once('hook:beforeDestroy', () => {
                clearTimeout(timer);
            });
            return timer;
        },
        /**
         * 字符串内所有小写转大写
         * @param str
         */
        $stringLowercaseToUppercase(str) {
            // 字符串转数组 遍历小写转大写
            return str.trim().split('').map(i => (/^[a-z]+$/).test(i) ? i.toUpperCase() : i).join('');
        },

        // 数组去重
        $distinct(arr) {
            let result = [];
            for (let i = 0; i < arr.length; i++) {
                for (let j = i + 1; j < arr.length; j++) {
                    if (arr[i] === arr[j]) {
                        j = ++i;
                    }
                }
                result.push(arr[i]);
            }
            return result;
        }
    }
};
